import extend from 'lodash/extend';
import { Component, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ISearchLocationModel, NavigationService } from '../../entire/services/navigation.service';
import { LocationManagerService } from '@cakeiteasy/web-utils';
import { CONTACT_FORM } from '@shared/constants/common.constants';
import { UserApiService } from '@cakeiteasy/order-process';

@Component({
  standalone: false,
  templateUrl: './contact-us-modal.component.html'
})
export class ContactUsModalComponent {
  public FORM = CONTACT_FORM;
  public showedForm: string = this.FORM.FAQ;
  public locationLoading: Promise<any>;
  public isSuccess: boolean = false;
  public showBack: boolean = true;

  constructor(public modal: NgbActiveModal,
              @Inject('AppConfig') private _appConfig: any,
              private _navigationService: NavigationService,
              private _user: UserApiService,
              private _locationManager: LocationManagerService) {
  }

  public onLocationFound(location: ISearchLocationModel) {
    this.locationLoading = new Promise<void>((res) => {
      this._navigationService.switchToDifferentLocation(location);
      setTimeout(() => {
        this.modal.close();
        res(null);
      }, 1000);
    });
  }

  public send(contactInfo) {

    extend(contactInfo, {
      isBusinessRequest: false,
      time: Date.now(),
      country_code: this._appConfig
        .countryDomainsMap[this._locationManager.getDomainName() || this._appConfig.defaultDomainName]
    });

    this._user.sendFeedback(contactInfo)
      .then(() => {
        this.isSuccess = true;
        setTimeout(() => {
          this.modal.close();
        }, 2000);
      });
  }
}
